import { useQuery } from '@tanstack/react-query'
import { finopsApi } from '@/api/finops'
import { useCurrentTenant, useCan } from '@/store/auth'

export function useFinopsData(month?: string) {
  const tenant = useCurrentTenant()
  const tenantId = tenant?.id
  const can = useCan()
  const canFinops = can('finops', 'read')

  const summary = useQuery({
    queryKey: ['finops-summary', tenantId],
    queryFn: () => finopsApi.getSummary(tenantId!),
    enabled: !!tenantId && canFinops,
    staleTime: 300_000,
  })

  const costByService = useQuery({
    queryKey: ['finops-cost-by-service', tenantId, month],
    queryFn: () => finopsApi.getCostByService(tenantId!, month),
    enabled: !!tenantId && canFinops,
    staleTime: 300_000,
  })

  const dailyCost = useQuery({
    queryKey: ['finops-daily-cost', tenantId, month],
    queryFn: () => finopsApi.getDailyCost(tenantId!, month),
    enabled: !!tenantId && canFinops,
    staleTime: 300_000,
  })

  const rightsizing = useQuery({
    queryKey: ['finops-rightsizing', tenantId],
    queryFn: () => finopsApi.getRightsizing(tenantId!),
    enabled: !!tenantId && canFinops,
    staleTime: 300_000,
  })

  const savingsPlans = useQuery({
    queryKey: ['finops-savings-plans', tenantId],
    queryFn: () => finopsApi.getSavingsPlans(tenantId!),
    enabled: !!tenantId && canFinops,
    staleTime: 300_000,
  })

  const idleResources = useQuery({
    queryKey: ['finops-idle-resources', tenantId],
    queryFn: () => finopsApi.getIdleResources(tenantId!),
    enabled: !!tenantId && canFinops,
    staleTime: 300_000,
  })

  return {
    tenant, tenantId, canFinops,
    summary, costByService, dailyCost,
    rightsizing, savingsPlans, idleResources,
  }
}
